import { Tag } from 'antd';
import React   from 'react';

export const HasStatementProcesses = ({ value, record }) => {
  if( !record?.statementProcesses?.length) {
    return <Tag color="orange">Nein</Tag>;
  }

  const cpr = record.statementProcesses.some(p => p.isCareProviderResponse === true);
  const stproc = record.statementProcesses.some(p => p.isCareProviderResponse !== true);
  return cpr && stproc ? <Tag color="blue">St.+Mit.</Tag> :
      ( cpr ? <Tag color="blue">Mitt.</Tag> : <Tag color="blue">Stn.</Tag> );
}
